import { NumericFormat } from 'react-number-format';
import { useSettings } from 'context/SettingsContext';
import { forwardRef, useEffect, useState } from 'react';

interface Props {
  value: number;
  onValueChange?: (values: any) => void;
  required?: boolean;
  allowNegative?: boolean;
  disabled?: boolean;
} 

const InputPriceRate = forwardRef<HTMLInputElement, Props>(
  (
    {
      value,
      onValueChange,
      required = false,
      allowNegative = true,
      disabled = false,
    },
    ref
  ) => {
    const { localSettings } = useSettings();
    const rate = Number(localSettings?.RATE?.current ?? 1) || 1;
    const isUahMode = rate === 1;

    const [valueUAH, setValueUAH] = useState(value * rate);

    useEffect(() => {
      if (!isUahMode) {
        setValueUAH(value * rate);
      }
    }, [value, rate, isUahMode]);

    return (
      <div className="d-flex">
        <NumericFormat
          disabled={disabled}
          allowNegative={allowNegative}
          className="form-control object-price"
          style={{
            borderRadius: isUahMode
              ? 'var(--bs-border-radius)'
              : 'var(--bs-border-radius) 0px 0px var(--bs-border-radius)',
          }}
          prefix={isUahMode ? '₴ ' : '$ '}
          thousandSeparator=","
          decimalScale={2}
          allowLeadingZeros
          value={value}
          required={required}
          onValueChange={onValueChange}
          getInputRef={(el) => {
            if (!ref) return;
            if (typeof ref === 'function') {
              ref(el);
            } else {
              ref.current = el;
            }
          }}
        />

        {!isUahMode && (
        <NumericFormat
          className="form-control object-price disable"
          style={{
            borderRadius: '0px var(--bs-border-radius) var(--bs-border-radius) 0px',
            borderLeft: 'none',
          }}
          prefix="₴ "
          disabled
          value={valueUAH.toFixed(2)}
          thousandSeparator=","
          decimalScale={2}
          allowLeadingZeros
        />
        )}
      </div>
    );
  }
);

export default InputPriceRate;
